import { useSessionSavedFilters } from "@/shared/hooks";
import type { FilterValue } from "@/ds";
import { PROFISSIONAIS_SAVED_FILTERS_SCREEN } from "../profissionais.constants";

/** Filtros salvos de Profissionais, por usuário e separados das demais telas; aplicar reaproveita o `aplicarFiltros` da lista. */
export function useProfissionaisFiltrosSalvos(aplicarFiltros: (value: FilterValue) => void) {
  const { savedFilters, saveFilter, deleteFilter, applySavedFilter } = useSessionSavedFilters(
    PROFISSIONAIS_SAVED_FILTERS_SCREEN,
  );

  return {
    savedFilters,
    onSaveFilter: saveFilter,
    onDeleteSavedFilter: deleteFilter,
    onApplySavedFilter: (id: string) => applySavedFilter(id, aplicarFiltros),
  };
}
